import React, { Component } from "react";
import { connect } from "react-redux";
import { assessmentActions } from "../../../_actions";
import HeaderTransprent from "../Home/Component/HeaderTransprent";
import Footer from "../Home/Component/Footer";
import AOS from "aos";
import Ready from "../../../components/Ready";
import { Helmet } from "react-helmet";
class TeenPersonalizedReport extends Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.state = {
      email: "",
      otp_code: "",
      notFoundText: "",
      showLogin: true,
      failureMSG: "",
      failureOTPMSG: "",
      quantity: 1,
      activeTab: 1,
      currentImage: null,
      saveSuccess: false,

      isScrolled: false,
      showButton1: false,
      showButton2: false,
      showButton3: false,
      showButton4: false,

      fieldslogin: {},
      errorslogin: {},

      formData: {
        quantity: 1,
        productId: this.props.match.params.id2,
        licensee: this.props.match.params.id1,
      },
    };
  }


  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.dispatch(assessmentActions.userAssessmentUserProfile('getAssessmentCartCount'));
    this.props.dispatch(assessmentActions.getAssessmentPackagesShortList());
    AOS.init({
      duration: 1000,
      once: true,
      easing: "ease-out",
      delay: 100,
    });
  }

  handleTabClick = (tab) => {
    this.setState({
      activeTab: tab,
    });
  };


  logout = () => {
    this.props.dispatch(assessmentActions.AssessmentUserLogout(this.props));
  };

  handleSignInPage = () => {
    localStorage.removeItem("route");
    localStorage.setItem("route", this.props.history.location.pathname);
    this.props.history.push(`/assessment/sign-in`);
  };

  gotoPage = (field) => {
    let { assessment } = this.props;
    let { userAssessmentUserProfileData } = assessment;

    if (field === "my-cart") {
      if (
        !(userAssessmentUserProfileData && userAssessmentUserProfileData.email)
      ) {
        this.props.history.push(`/assessment/` + "sign-in");
      } else {
        this.props.history.push(`/assessment/` + field);
      }
    } else {
      this.props.history.push(`/assessment/` + field);
    }
  };

  gotoMyAccount = (field) => {
    let userDetails = this.props.assessment.userAssessmentUserProfileData;
    if (userDetails && userDetails.email) {
      this.props.history.push(`/assessment/` + field);
    } else {
      localStorage.removeItem("route");
      localStorage.setItem("route", `/assessment/` + field);
      this.props.history.push(`/assessment/sign-in`);
    }
  };

  handleDownload = () => {
    let code = "TalentPlusStrengths21";
    const link = document.createElement("a");
    link.href = "/" + code.toString() + ".pdf";
    link.download = code.toString() + ".pdf";
    link.click();
  };

  handleRedirect = () => {
    this.props.history.push("/assessment/how-talentplus-strength-works");
    window.scrollTo(0, 0);
  };

  closeOrgTypeModal = () => {
    this.setState({ showOrgTypeModal: false })
  }

  handleOptionInput = (value) => {
    let { formData } = this.state;
    formData["type"] = value;
    this.setState({ formData });
  };

  handleOptionSubmit = () => {
    let { formData } = this.state;
    if (formData["type"] === "Individual") {
      this.props.history.push(`/assessment/` + "surveylogin");
    } else if (formData["type"] === "Organization") {
      window.location.href = 'https://plusinsight.happyplus.in/surveylink/#/assessment/signin';
    }
  };

  handleTakeAssessmentRedirect = () => {
    this.setState({ showOrgTypeModal: false }, () => {
      this.handleOptionSubmit();
    })
  }

  inputChange = (e) => {
    e.preventDefault();
    let { name, value } = e.target;
    let fieldslogin = this.state.fieldslogin;
    let errorslogin = this.state.errorslogin;
    fieldslogin[name] = value;
    errorslogin[name] = "";
    this.setState({ fieldslogin, errorslogin });
  };

  loginSubmit = () => {
    console.log(
      "this.handleValidationLogin()---->",
      this.handleValidationLogin()
    );

    if (this.handleValidationLogin()) {
      let { userName, email, phone, message } =
        this.state.fieldslogin;
      this.setState({ saveSuccess: true });
      this.props.dispatch(
        assessmentActions.saveAssessmentContactUs(
          {
            name: userName,
            email: email,
            phone: phone,
            message: message,
          },
          this.props
        )
      );
      setTimeout(() => {
        this.setState({ saveSuccess: false });
      }, 4000);
    }
  };

  handleValidationLogin = () => {
    let { fieldslogin } = this.state;
    let errorslogin = {};
    let formIsValid = 0;

    function validateEmail(email) {
      const re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }

    //userName
    if (!fieldslogin["userName"] || fieldslogin["userName"] === "") {
      formIsValid += 1;
      console.log("1 userName !");
      errorslogin["userName"] = "Full name is required";
    }
    //email
    if (!fieldslogin["email"]) {
      console.log("1 email !");

      formIsValid += 1;
      errorslogin["email"] = "Email is required";
    } else {
      if (!validateEmail(fieldslogin["email"])) {
        formIsValid += 1;
        errorslogin["email"] = "Please enter valid email";
      }
    }

    this.setState({ errorslogin: errorslogin });

    return formIsValid ? false : true;
  };

  scrollToElement = () => {
    if (this.myRef.current) {
      const offset = 180; // Adjust the offset value as needed
      const elementPosition = this.myRef.current.offsetTop - offset;
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
  };

  render() {

    let { assessment } = this.props;
    let {
      userAssessmentUserProfileData,
      getAssessmentCartCountData,
      getAssessmentPackagesShortListData,
    } = assessment;
    // console.log("quantity-->", quantity);
    const cards = [

      {
        id: 1,
        title: 'Celebrating Uniqueness',
        dics: `Recognizes and celebrates the unique talents and abilities of each teenager, valuing their individuality.`,
        icon: '/img/assessment/teentalent/celebrating-uniqueness.svg',
      },
      {
        id: 2,
        title: 'Holistic Evaluation',
        dics: `Challenges traditional success metrics, offering a comprehensive evaluation that goes beyond narrow criteria.`,
        icon: '/img/assessment/teentalent/holistic-evaluation.svg',
      },
      {
        id: 3,
        title: 'Navigating Expectations',
        dics: `Guides teenagers through societal pressures, empowering them to resist predefined expectations and find their authentic path.`,
        icon: '/img/assessment/teentalent/navigating-expectations.svg',
      },
      {
        id: 4,
        title: 'Avoiding Mismatch',
        dics: `Raises awareness about the consequences of pursuing roles misaligned with natural talents, preventing potential wasted potential and struggles.`,
        icon: '/img/assessment/teentalent/avoiding-mismatch.svg',
      },
      {
        id: 5,
        title: 'Purposeful Living',
        dics: `Emphasizes the importance of aligning work with passions, talents, and purpose for a fulfilling and purpose-driven life.`,
        icon: '/img/assessment/teentalent/purposeful-living.svg',
      },
      {
        id: 6,
        title: 'Guiding Alignment',
        dics: `Serves as a compass, guiding teenagers to align their unique talents with both their work and life.`,
        icon: '/img/assessment/teentalent/guiding-alignment.svg',
      },
      {
        id: 7,
        title: 'Empowering Contribution',
        dics: `Enables teenagers to make meaningful contributions by aligning their work with their inherent talents.`,
        icon: '/img/assessment/teentalent/empowering-contribution.svg',
      },
      {
        id: 8,
        title: 'Self-Trust and Confidence',
        dics: `Encourages self-trust, fostering confidence in teenagers to create a life that resonates authentically with their true essence.`,
        icon: '/img/assessment/teentalent/self-trust-and-confidence.svg',
      },
    ]


    return (
      <div className="overflow-hidden ">
        <Helmet>
          <meta charSet="utf-8" />
          <title>Empowering Teen Talent Potential for Meaningful Growth</title>
          <meta name="description" content="Elevate teen potential with Teenager Talent assessment, fostering confidence, purposeful living, and transformative growth." />
          <link rel="canonical" href="https://www.talentplusstrengths.com/#/assessment/home" />
        </Helmet>


        {/* <TestHeader
          handleTakeAssessmentRedirect={this.handleTakeAssessmentRedirect}
        /> */}

        <section
          className="bg-gradient-to-b from-[#2196F3]/20 w-full h-auto bg-center  bg-cover bg-no-repeat  "
        >
          <HeaderTransprent
            handleSignInPage={this.handleSignInPage}
            userDetails={userAssessmentUserProfileData}
            logout={this.logout}
            gotoPage={this.gotoPage}
            cartCount={getAssessmentCartCountData ? getAssessmentCartCountData : 0}
            props2={this.props}
            prodList={getAssessmentPackagesShortListData}
            gotoMyAccount={this.gotoMyAccount}
          />

          {/* Hero Section */}
          <div className="w-full h-full border-t border-black/10">
            <div data-aos="fade-right" className="text-base text-[#212121] font-normal pt-4 left-0 2xl:w-9/12 xl:w-11/12 xl:px-0 px-4 mx-auto">
              <span className="cursor-pointer" onClick={() => this.gotoPage("home")}>Home</span>  {'>'}  <span className="cursor-pointer" onClick={() => this.gotoPage("teen-career-guidance")}>Career Guidance Program</span>  {'>'}  <span className="text-[#2196F3]">Your Personalized Report</span>
            </div>
            <div className="flex flex-col items-center w-full h-full gap-10  md:pt-10  md:flex-row 2xl:w-9/12 xl:w-11/12 xl:px-0 px-4 mx-auto  ">

              <div className="flex flex-col justify-center w-full h-full pt-10 mx-auto   space-y-8 text-center md:pb-10 md:pt-0 md:text-left relative  ">

                <h1 data-aos="fade-right" className="xl:text-5xl text-4xl leading-[3rem] xl:leading-[3.5rem] font-bold text-[#212121]  capitalize">Your Personalized Report </h1>
                <div data-aos="fade-right" className="text-base font-light md:text-lg">
                  <p className="text-[#212121]">This report provides a comprehensive analysis of your responses to the Career Guidance Program
                    Assessment. Its purpose is to help you better understand your potential, personality, and career interests, thereby assisting you in aligning these attributes with your academic and career aspirations.
                    <br />
                    <br />

                    The report also
                    offers a variety of career recommendations tailored to your personal profile, opening a wide range of
                    possibilities for you to explore.</p>
                </div>

              </div>

              <div className="flex items-end justify-center w-full lg:justify-end">
                <img data-aos="fade-left" src="/img/assessment/report.webp" alt="report" className="z-0 w-full" />
              </div>
            </div>
          </div>
        </section>



        <section className="w-full px-4 mx-auto bg-white 2xl:w-9/12 xl:w-11/12 xl:px-0 ">
          <div className="pt-10 mx-auto space-y-4 text-center">
            <h1
              data-aos="fade-up"
              className="2xl:text-5xl md:text-4xl text-3xl xl:leading-[3rem] 2xl:leading-[4rem]  capitalize font-bold text-[#212121]"
            >As you go through the report, <br /> keep the following in mind</h1>
            <p data-aos="fade-up" className="md:text-lg text-base text-[#212121]">

            </p>
          </div>
        </section>
        {/* Learning section 1*/}
        <section className="py-20">
          <div className="items-center w-full gap-10 px-4   mx-auto   2xl:w-9/12 xl:w-11/12 xl:px-0 md:flex-row ">
            <div className="grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 lg:gap-6 gap-10 w-full  ">
              <div data-aos="fade-up" className=" w-full bg-gradient-to-b from-[#2196F3]/10  p-6 gap-6 flex flex-col items-center">
                <div className="w-16 h-16 rounded-full flex items-center justify-center bg-[#2196F3] -mt-14">
                  <span className="text-3xl font-medium text-white">1</span>
                </div>
                <p className="text-center text-lg font-medium">
                  The information and insights provided are based solely on your responses to the Career Guidance Program Assessment.
                </p>
              </div>
              <div data-aos="fade-up" className=" w-full bg-gradient-to-b from-[#2196F3]/10  p-6 gap-6 flex flex-col items-center">
                <div className="w-16 h-16 rounded-full flex items-center justify-center bg-[#2196F3] -mt-14">
                  <span className="text-3xl font-medium text-white">2</span>
                </div>
                <p className="text-center text-lg font-medium">
                  The career recommendations in this report are intended to broaden your options, not limit them.
                </p>
              </div>
              <div data-aos="fade-up" className=" w-full bg-gradient-to-b from-[#2196F3]/10  p-6 gap-6 flex flex-col items-center">
                <div className="w-16 h-16 rounded-full flex items-center justify-center bg-[#2196F3] -mt-14">
                  <span className="text-3xl font-medium text-white">3</span>
                </div>
                <p className="text-center text-lg font-medium">
                  Don't
                  focus on finding the "perfect" career, but rather consider a variety of factors when narrowing down your
                  choices.

                </p>
              </div>
              <div data-aos="fade-up" className=" w-full bg-gradient-to-b from-[#2196F3]/10  p-6 gap-6 flex flex-col items-center">
                <div className="w-16 h-16 rounded-full flex items-center justify-center bg-[#2196F3] -mt-14">
                  <span className="text-3xl font-medium text-white">4</span>
                </div>
                <p className="text-center text-lg font-medium">
                  This report represents a single source of evidence. Therefore, it is advisable to supplement it with
                  additional data, such as academic grades, extracurricular achievements, and real-world experiences.
                </p>
              </div>
            </div>
          </div>
        </section>


        <section
          className="bg-[#2196F3]/10 w-full h-auto bg-center  bg-cover bg-no-repeat py-10 md:py-20  "
          style={{
            backgroundImage: `url('/img/assessment/bg-gradient.webp')`,
          }}
        >

          <div className=" w-full gap-10 px-4 mx-auto   2xl:w-9/12 xl:w-11/12 xl:px-0  space-y-10  ">

            <div className="space-y-4 text-center ">
              <h1 className="xl:text-5xl text-4xl leading-[3rem] xl:leading-[4rem]  capitalize font-bold text-[#212121]">Key Benefits of this Report</h1>

            </div>

            <section className="flex flex-col items-center w-full gap-10  lg:flex-row ">
              {/* img */}
              <div className="flex justify-end w-full ">
                <img data-aos="fade-left" className="lg:w-full md:w-4/6 w-full  mx-auto " src="/img/assessment/key-benefits-report.webp" alt="key-benefits-report" />
              </div>
              {/* text */}
              <div
                data-aos="fade-right"
                className="grid w-full grid-cols-1 gap-6 text-left md:grid-cols-2"
              >
                <div className="flex flex-col bg-[#fff] p-6 px-4 gap-4 rounded-md items-start box-shadow-custom  w-full hover:border-[#2196F3] border border-transparent ">

                  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 72 72" fill="none">
                    <path d="M16.0032 55.0699C7.45074 55.0699 0.492188 62.03 0.492188 70.5843C0.492188 71.0933 0.904856 71.5069 1.41458 71.5069H30.5917C31.1007 71.5069 31.5141 71.0941 31.5141 70.5843C31.5141 62.03 24.5556 55.0699 16.0032 55.0699ZM2.36774 69.6617C2.84353 62.5532 8.77712 56.915 16.0032 56.915C23.2292 56.915 29.1628 62.5532 29.6386 69.6625L2.36774 69.6617ZM16.0032 54.238C20.5693 54.238 24.2841 50.5224 24.2841 45.9552C24.2841 41.388 20.5693 37.6724 16.0032 37.6724C11.437 37.6724 7.72217 41.388 7.72217 45.9552C7.72217 50.5224 11.437 54.238 16.0032 54.238ZM16.0032 39.5176C19.5523 39.5176 22.4394 42.4053 22.4394 45.9552C22.4394 49.5051 19.5523 52.3928 16.0032 52.3928C12.4541 52.3928 9.56695 49.5051 9.56695 45.9552C9.56695 42.4053 12.4541 39.5176 16.0032 39.5176ZM31.3121 49.546C31.3121 50.055 31.7248 50.4686 32.2345 50.4686H61.4117C61.9206 50.4686 62.3341 50.0558 62.3341 49.546C62.3341 40.9917 55.3755 34.0316 46.8231 34.0316C38.2707 34.0316 31.3121 40.9909 31.3121 49.546ZM60.4593 48.6234H33.1877C33.6635 41.5149 39.5979 35.876 46.8231 35.876C54.0484 35.876 59.9827 41.5149 60.4593 48.6234ZM38.5429 24.9169C38.5429 29.4841 42.2577 33.1997 46.8239 33.1997C51.3901 33.1997 55.1049 29.4841 55.1049 24.9169C55.1049 20.3497 51.3901 16.6341 46.8239 16.6341C42.2577 16.6341 38.5429 20.3497 38.5429 24.9169ZM53.2601 24.9169C53.2601 28.4668 50.373 31.3546 46.8239 31.3546C43.2748 31.3546 40.3877 28.4668 40.3877 24.9169C40.3877 21.367 43.2748 18.4793 46.8239 18.4793C50.373 18.4793 53.2601 21.367 53.2601 24.9169ZM71.5059 1.41576V60.9764C71.5059 61.4854 71.0932 61.8989 70.5835 61.8989H32.5943C32.0854 61.8989 31.6719 61.4862 31.6719 60.9764C31.6719 60.4665 32.0846 60.0538 32.5943 60.0538H69.6611V2.33835H23.9851V37.2746C23.9851 37.7837 23.5724 38.1972 23.0627 38.1972C22.5538 38.1972 22.1403 37.7844 22.1403 37.2746V1.41576C22.1403 0.906714 22.553 0.493164 23.0627 0.493164H70.5835C71.0932 0.493164 71.5059 0.905924 71.5059 1.41576ZM31.4794 18.5962C31.1196 18.2363 31.1196 17.6523 31.4794 17.2916L38.9816 9.78777C39.3414 9.4271 39.9253 9.4271 40.2859 9.78777C40.6457 10.1477 40.6457 10.7317 40.2859 11.0923L32.7837 18.5962C32.6038 18.7762 32.3679 18.8661 32.1319 18.8661C31.8952 18.8669 31.6593 18.7769 31.4794 18.5962Z" fill="#2196F3" />
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M23.0637 0.986301C22.8267 0.986301 22.6344 1.17868 22.6344 1.41574V37.2746C22.6344 37.5119 22.8269 37.704 23.0637 37.704C23.3007 37.704 23.4929 37.5117 23.4929 37.2746V1.84519H70.1552V60.5469H32.5953C32.358 60.5469 32.166 60.7388 32.166 60.9763C32.166 61.2136 32.3585 61.4058 32.5953 61.4058H70.5845C70.8214 61.4058 71.0137 61.2134 71.0137 60.9763V1.41574C71.0137 1.17816 70.8217 0.986301 70.5845 0.986301H23.0637ZM21.6481 1.41574C21.6481 0.634719 22.2812 0 23.0637 0H70.5845C71.3667 0 72 0.633657 72 1.41574V60.9763C72 61.7574 71.3669 62.3921 70.5845 62.3921H32.5953C31.8142 62.3921 31.1797 61.7587 31.1797 60.9763C31.1797 60.1942 31.8131 59.5606 32.5953 59.5606H69.1689V2.83149H24.4792V37.2746C24.4792 38.0556 23.8461 38.6903 23.0637 38.6903C22.2826 38.6903 21.6481 38.057 21.6481 37.2746V1.41574ZM39.9381 10.1364C39.7699 9.96818 39.4986 9.96873 39.3317 10.136L31.8295 17.6399C31.6615 17.8083 31.6621 18.0804 31.8291 18.2475L31.8299 18.2483C31.9132 18.332 32.021 18.3733 32.1313 18.373L32.1329 18.373C32.2435 18.373 32.3523 18.3312 32.4359 18.2475L39.9377 10.744C40.1057 10.5756 40.1052 10.3035 39.9381 10.1364ZM38.6334 9.43946C39.1861 8.88543 40.0826 8.88598 40.6356 9.43908C41.1882 9.99175 41.1876 10.8877 40.636 11.4406L33.1334 18.9449C32.8572 19.2211 32.4942 19.3593 32.1329 19.3593V18.8661L32.1346 19.3593C31.7713 19.3605 31.4074 19.2219 31.1309 18.9441C30.5791 18.3914 30.5799 17.496 31.1312 16.9433L38.6334 9.43946ZM38.0507 24.9169C38.0507 20.0775 41.9862 16.1409 46.8249 16.1409C51.6635 16.1409 55.599 20.0775 55.599 24.9169C55.599 29.3056 52.3624 32.9518 48.1508 33.5929C56.3574 34.2696 62.8282 41.1662 62.8282 49.546C62.8282 50.3283 62.1938 50.9617 61.4126 50.9617H32.2355C31.453 50.9617 30.8199 50.327 30.8199 49.546C30.8199 41.1651 37.2913 34.269 45.4983 33.5928C41.287 32.9515 38.0507 29.3054 38.0507 24.9169ZM46.8249 17.1272C42.5311 17.1272 39.037 20.622 39.037 24.9169C39.037 29.2118 42.5311 32.7066 46.8249 32.7066C51.1186 32.7066 54.6127 29.2118 54.6127 24.9169C54.6127 20.622 51.1186 17.1272 46.8249 17.1272ZM46.8249 18.9724C43.5482 18.9724 40.8818 21.6393 40.8818 24.9169C40.8818 28.1945 43.5482 30.8614 46.8249 30.8614C50.1015 30.8614 52.7679 28.1945 52.7679 24.9169C52.7679 21.6393 50.1015 18.9724 46.8249 18.9724ZM39.8955 24.9169C39.8955 21.0948 43.0033 17.9861 46.8249 17.9861C50.6464 17.9861 53.7542 21.0948 53.7542 24.9169C53.7542 28.7391 50.6464 31.8477 46.8249 31.8477C43.0033 31.8477 39.8955 28.7391 39.8955 24.9169ZM46.8241 34.5247C38.5441 34.5247 31.8062 41.2632 31.8062 49.546C31.8062 49.783 31.9985 49.9754 32.2355 49.9754H61.4126C61.6494 49.9754 61.8419 49.7833 61.8419 49.546C61.8419 41.2639 55.104 34.5247 46.8241 34.5247ZM33.7265 48.1302H59.9224C59.2136 41.5286 53.6085 36.3691 46.8241 36.3691C40.0396 36.3691 34.4346 41.5287 33.7265 48.1302ZM32.6966 48.5905C33.1896 41.225 39.3372 35.3828 46.8241 35.3828C54.3109 35.3828 60.4585 41.225 60.9523 48.5904L60.9876 49.1165H32.6614L32.6966 48.5905ZM7.22998 45.9552C7.22998 41.1157 11.1655 37.1792 16.0041 37.1792C20.8428 37.1792 24.7783 41.1157 24.7783 45.9552C24.7783 50.3438 21.5418 53.9899 17.3304 54.6311C25.5372 55.3076 32.0082 62.2043 32.0082 70.5843C32.0082 71.3666 31.3738 72 30.5927 72H1.41554C0.633086 72 0 71.3653 0 70.5843C0 62.2043 6.47109 55.3076 14.6779 54.6311C10.4664 53.9899 7.22998 50.3438 7.22998 45.9552ZM16.0041 38.1655C11.7104 38.1655 8.21629 41.6602 8.21629 45.9552C8.21629 50.2501 11.7104 53.7449 16.0041 53.7449C20.2978 53.7449 23.792 50.2501 23.792 45.9552C23.792 41.6602 20.2978 38.1655 16.0041 38.1655ZM16.0041 40.0107C12.7275 40.0107 10.0611 42.6775 10.0611 45.9552C10.0611 49.2328 12.7275 51.8997 16.0041 51.8997C19.2808 51.8997 21.9472 49.2328 21.9472 45.9552C21.9472 42.6775 19.2808 40.0107 16.0041 40.0107ZM9.07476 45.9552C9.07476 42.133 12.1826 39.0244 16.0041 39.0244C19.8257 39.0244 22.9335 42.133 22.9335 45.9552C22.9335 49.7773 19.8257 52.886 16.0041 52.886C12.1826 52.886 9.07476 49.7773 9.07476 45.9552ZM16.0041 55.563C7.72417 55.563 0.986301 62.3022 0.986301 70.5843C0.986301 70.8213 1.17855 71.0137 1.41554 71.0137H30.5927C30.8294 71.0137 31.0219 70.8216 31.0219 70.5843C31.0219 62.3022 24.2841 55.563 16.0041 55.563ZM2.90654 69.1685L29.1017 69.1693C28.3937 62.567 22.7894 57.4082 16.0041 57.4082C9.21889 57.4082 3.61458 62.567 2.90654 69.1685ZM1.87665 69.6287C2.36964 62.2633 8.51651 56.4219 16.0041 56.4219C23.4918 56.4219 29.6386 62.2633 30.1316 69.6295L30.1668 70.1556L1.84144 70.1548L1.87665 69.6287Z" fill="#2196F3" />
                  </svg>

                  <div className="text-[#212121] space-y-1.5 ">
                    <p className="text-lg font-semibold leading-6">Self-Awareness </p>
                    <p className="text-base font-normal">It provides a better understanding of your abilities, personal characteristics, interests, and
                      preferences.
                    </p>
                  </div>
                </div>

                <div className="flex flex-col bg-[#fff] p-6 px-4 gap-4 rounded-md items-start box-shadow-custom  w-full hover:border-[#2196F3] border border-transparent ">
                  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 72 72" fill="none">
                    <path d="M62.8788 17.6407H57.1851C57.3896 17.0069 57.4918 16.3527 57.4918 15.6781C57.4918 12.1106 54.5785 9.20754 51.0008 9.20754C47.4333 9.20754 44.5303 12.1106 44.5303 15.6781C44.5303 16.3527 44.6325 17.0172 44.8369 17.6407H35.9642C35.954 17.6407 35.9336 17.6509 35.9233 17.6509H26.6009C26.8973 16.9149 27.0404 16.1176 27.0404 15.2896C27.0404 13.1839 26.008 11.2111 24.2907 10.0355C23.0334 9.14621 21.4592 8.74755 19.8748 8.92133C17.1353 9.21776 14.8558 11.3235 14.3242 14.0323C14.0789 15.259 14.2016 16.5163 14.6513 17.6509H9.13145C6.29995 17.6509 4 19.9509 4 22.7824V49.5538C4 52.3853 6.29995 54.6853 9.13145 54.6853H35.954H35.9642H44.8267C44.6223 55.3088 44.52 55.9732 44.52 56.6479C44.52 60.2154 47.4231 63.1184 50.9906 63.1184C54.5683 63.1184 57.4815 60.2154 57.4815 56.6479C57.4815 55.9834 57.3793 55.319 57.1749 54.6853H62.8685C65.7 54.6853 68 52.3853 68 49.5538V22.7721C68 19.9406 65.7 17.6407 62.8788 17.6407ZM6.57595 49.5538V22.7824C6.57595 21.3717 7.73103 20.2166 9.14167 20.2166H16.9922C17.5135 20.2166 17.9735 19.91 18.1779 19.4296C18.3721 18.9491 18.2699 18.4073 17.9122 18.0394C17.0024 17.1194 16.6037 15.8007 16.8593 14.5332C17.1659 12.9386 18.5664 11.6608 20.1814 11.4768C21.1423 11.3644 22.093 11.5995 22.8494 12.1413C23.8818 12.8568 24.5053 14.0323 24.5053 15.2896C24.5053 16.3323 24.0965 17.2931 23.3707 18.0087C22.9925 18.3767 22.88 18.9287 23.0743 19.4091C23.2685 19.8895 23.7387 20.2064 24.26 20.2064H34.6762V30.7862C34.3083 30.684 33.9198 30.6329 33.5314 30.6022C33.47 30.6022 33.3985 30.592 33.3372 30.592C33.2247 30.5818 33.1225 30.5715 33.0101 30.5715C32.8363 30.5715 32.683 30.6124 32.5092 30.6226C32.3865 30.6329 32.2639 30.6226 32.1412 30.6329C32.0696 30.6431 32.0083 30.6635 31.9367 30.6738C31.763 30.7044 31.5892 30.7453 31.4154 30.7862C31.211 30.8373 31.0065 30.8986 30.8123 30.9702C30.6386 31.0315 30.4648 31.1031 30.291 31.1849C30.1377 31.2564 29.9843 31.3484 29.8412 31.4302C29.647 31.5426 29.463 31.6448 29.279 31.7777C29.2177 31.8186 29.1666 31.8697 29.1053 31.9208C28.6146 32.2991 28.175 32.7386 27.8173 33.2395C27.8173 33.2497 27.8071 33.2497 27.7968 33.2599C27.6537 33.4541 27.5311 33.6688 27.4186 33.8835C27.3471 34.0061 27.2755 34.1288 27.2142 34.2515C27.1222 34.4457 27.0506 34.6399 26.9791 34.8443C26.9177 35.0181 26.8666 35.1817 26.8155 35.3554C26.7644 35.5497 26.7235 35.7439 26.6826 35.9483C26.6724 36.0096 26.652 36.071 26.6417 36.1323C26.6111 36.3674 26.5906 36.6025 26.5906 36.8376C26.5906 36.8785 26.5804 36.9194 26.5804 36.9603C26.5804 37.0421 26.6009 37.1238 26.6009 37.2056C26.6111 37.4918 26.6417 37.7678 26.6826 38.054C26.7133 38.2074 26.744 38.3505 26.7746 38.5038C26.836 38.7594 26.9177 39.0047 27.0097 39.25C27.0609 39.3727 27.1017 39.4851 27.1528 39.6078C27.2755 39.8838 27.4186 40.1496 27.5822 40.3949C27.6231 40.4664 27.6742 40.538 27.7151 40.6095C27.8582 40.814 28.0115 41.0184 28.175 41.2024C28.2364 41.2638 28.2977 41.3251 28.359 41.3864C28.4204 41.4478 28.4715 41.5091 28.5328 41.5602C28.7781 41.7953 29.0439 42.01 29.3199 42.2042C29.3812 42.2451 29.4528 42.2962 29.5141 42.3371C29.8003 42.5211 30.107 42.6948 30.4239 42.8277C30.4852 42.8584 30.5466 42.8788 30.6079 42.8993C30.9452 43.0322 31.303 43.1548 31.6608 43.2264C31.6812 43.2366 31.7119 43.2366 31.7425 43.2366C32.1514 43.3184 32.5705 43.3695 32.9998 43.3695C33.562 43.3695 34.114 43.2979 34.6456 43.1651V52.0889H9.13145C7.72081 52.1195 6.57595 50.9644 6.57595 49.5538ZM65.4343 49.5538C65.4343 50.9644 64.2792 52.1195 62.8685 52.1195H55.0487C54.5581 52.1195 54.1083 52.4057 53.8936 52.8555C53.679 53.3053 53.7403 53.8266 54.0572 54.215C54.6194 54.9101 54.926 55.7586 54.926 56.6479C54.926 58.8047 53.1679 60.5527 51.0008 60.5527C48.8439 60.5527 47.096 58.7945 47.096 56.6479C47.096 55.7381 47.3924 54.8999 47.9546 54.2253C48.2715 53.847 48.3329 53.3155 48.1284 52.8657C47.9137 52.416 47.464 52.1297 46.9733 52.1297H37.2522V41.2024C37.2522 41.0798 37.2317 40.9571 37.2011 40.8447C37.0989 40.4767 36.8433 40.1598 36.4753 40.0065C36.0256 39.8122 35.5145 39.894 35.1465 40.2109C34.9318 40.354 34.6865 40.4664 34.4514 40.5687C34.3083 40.6198 34.1651 40.6811 34.0118 40.7118C34.0016 40.7118 33.9914 40.7118 33.9811 40.722C32.8772 40.9673 31.6505 40.7322 30.7101 40.0473C30.6692 40.0167 30.6283 39.986 30.5874 39.9451C30.4546 39.8429 30.3319 39.7202 30.2092 39.5976C30.1581 39.5362 30.107 39.4749 30.0559 39.4034C29.9435 39.2602 29.831 39.1171 29.739 38.9536C29.6981 38.882 29.6572 38.8003 29.6164 38.7185C29.5346 38.5651 29.463 38.4016 29.4119 38.238C29.3812 38.1563 29.3608 38.0745 29.3404 37.9927C29.2892 37.8087 29.2586 37.6247 29.2381 37.4305C29.2279 37.359 29.2177 37.2874 29.2177 37.2261C29.2075 37.0216 29.2075 36.807 29.2279 36.5923C29.2381 36.531 29.2381 36.4594 29.2484 36.3981C29.2688 36.255 29.2995 36.1221 29.3404 35.9892C29.3608 35.8972 29.3915 35.8052 29.4221 35.7234C29.463 35.6008 29.5141 35.4679 29.5755 35.3452C29.6164 35.2737 29.6572 35.2021 29.6981 35.1306C29.7697 35.0079 29.8412 34.875 29.923 34.7626C29.9435 34.7421 29.9639 34.7217 29.9843 34.691C30.1786 34.4355 30.4034 34.2003 30.659 34.0061C30.7203 33.9652 30.7714 33.9141 30.8225 33.863C30.9248 33.7915 31.027 33.7301 31.1292 33.6688C31.2212 33.6177 31.3234 33.5564 31.4256 33.5053C31.5279 33.4541 31.6301 33.4235 31.7323 33.3826C31.8447 33.3417 31.9572 33.3008 32.0799 33.2701C32.1923 33.2395 32.3047 33.2088 32.4172 33.1986C32.5194 33.1782 32.6216 33.1782 32.7136 33.1679C32.8772 33.1577 33.0407 33.1373 33.2043 33.1475C33.2554 33.1475 33.2963 33.1577 33.3474 33.1577C33.5109 33.1679 33.6745 33.1986 33.8278 33.2293C33.9096 33.2497 33.9914 33.2599 34.0731 33.2804C34.1754 33.311 34.2776 33.3519 34.3798 33.3826C34.6558 33.4848 34.9216 33.6075 35.1567 33.771C35.5349 34.0879 36.0562 34.1697 36.506 33.9755C36.8638 33.8119 37.1193 33.5053 37.2215 33.1373C37.2522 33.0248 37.2726 32.9022 37.2726 32.7795V20.2064H46.9835C47.4742 20.2064 47.924 19.9202 48.1386 19.4807C48.3533 19.0411 48.292 18.5096 47.9853 18.1211C47.4231 17.4158 47.1267 16.5776 47.1267 15.6781C47.1267 13.5212 48.8848 11.7733 51.0315 11.7733C53.1985 11.7733 54.9567 13.5315 54.9567 15.6781C54.9567 16.5572 54.6603 17.4056 54.0878 18.1314C53.7812 18.5198 53.7301 19.0411 53.9447 19.4807C54.1594 19.9202 54.6092 20.2064 55.0998 20.2064H62.9094C64.3201 20.2064 65.4752 21.3513 65.4752 22.7721V49.5538H65.4343Z" fill="#2196F3" stroke="#2196F3" strokeWidth="0.5" />
                  </svg>

                  <div className="text-[#212121] space-y-1.5 ">
                    <p className="text-lg font-semibold leading-6">Career Matching </p>
                    <p className="text-base font-normal"> It identifies career options that align with your personal profile.

                    </p>
                  </div>
                </div>

                <div className="flex flex-col bg-[#fff] p-6 px-4 gap-4 rounded-md items-start box-shadow-custom  w-full hover:border-[#2196F3] border border-transparent ">
                  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 74 73" fill="none">
                    <path d="M56.6863 48.6763C53.1871 48.6763 50.3359 51.5275 50.3359 55.0267C50.3359 58.5259 53.1871 61.3771 56.6863 61.3771C60.1855 61.3771 63.0367 58.5259 63.0367 55.0267C63.0367 51.5275 60.1855 48.6763 56.6863 48.6763ZM56.6863 59.4115C54.2671 59.4115 52.3015 57.4459 52.3015 55.0267C52.3015 52.6075 54.2671 50.6419 56.6863 50.6419C59.1055 50.6419 61.0711 52.6075 61.0711 55.0267C61.0711 57.4459 59.1055 59.4115 56.6863 59.4115Z" fill="#2196F3" stroke="#2196F3" strokeWidth="0.5" />
                    <path d="M71.3296 51.9731H68.4928C68.3272 51.4835 68.1256 51.0011 67.8952 50.5403L69.904 48.5315C70.5592 47.8763 70.5592 46.8179 69.904 46.1699L66.5416 42.8075C65.8864 42.1523 64.828 42.1523 64.1728 42.8075L62.164 44.8163C61.696 44.5859 61.2208 44.3915 60.7312 44.2187V41.3819C60.7312 40.4603 59.9824 39.7115 59.0608 39.7115H57.664V3.42347C57.664 1.85387 56.3896 0.572266 54.8128 0.572266H3.8512C2.2744 0.579466 1 1.85387 1 3.42347V59.9651C1 61.5347 2.2744 62.8163 3.8512 62.8163H18.4096V63.6259C18.4096 64.6339 19.2304 65.4475 20.2312 65.4475H38.44C39.448 65.4475 40.2616 64.6267 40.2616 63.6259V62.8163H44.1712L43.4656 63.5219C42.8104 64.1771 42.8104 65.2355 43.4656 65.8835L46.828 69.2459C47.4832 69.9011 48.5416 69.9011 49.1968 69.2459L51.2056 67.2371C51.6736 67.4675 52.1488 67.6619 52.6384 67.8347V70.6715C52.6384 71.5931 53.3872 72.3419 54.3088 72.3419H59.0608C59.9824 72.3419 60.7312 71.5931 60.7312 70.6715V67.8347C61.2208 67.6691 61.7032 67.4675 62.164 67.2371L64.1728 69.2459C64.828 69.9011 65.8864 69.9011 66.5416 69.2459L69.904 65.8835C70.5592 65.2283 70.5592 64.1699 69.904 63.5219L67.8952 61.5131C68.1256 61.0451 68.32 60.5699 68.4928 60.0803H71.3296C72.2512 60.0803 73 59.3315 73 58.4099V53.6579C73 52.7291 72.2512 51.9731 71.3296 51.9731ZM2.9656 59.9651V3.42347C2.9656 2.94107 3.3616 2.54507 3.844 2.54507H54.8128C55.2952 2.54507 55.6912 2.94107 55.6912 3.42347V39.7115H54.2944C53.3728 39.7115 52.624 40.4603 52.624 41.3819V44.2187C52.1344 44.3843 51.652 44.5859 51.1912 44.8163L49.1824 42.8075C48.5272 42.1523 47.4688 42.1523 46.8136 42.8075L43.4512 46.1699C43.2784 46.3427 43.156 46.5443 43.0768 46.7531H26.4304C25.8904 46.7531 25.444 47.1923 25.444 47.7395C25.444 48.2795 25.8832 48.7259 26.4304 48.7259H43.6456L45.4672 50.5475C45.2368 51.0155 45.0424 51.4907 44.8696 51.9803H42.04C41.536 51.9803 41.0824 52.2035 40.7728 52.5635H26.4304C25.8904 52.5635 25.444 53.0027 25.444 53.5499C25.444 54.0899 25.8832 54.5363 26.4304 54.5363H40.3624V58.4171C40.3624 59.3387 41.1112 60.0875 42.0328 60.0875H44.8696C44.956 60.3467 45.0568 60.5987 45.1648 60.8579H39.2752H19.3888H3.8512C3.3616 60.8435 2.9656 60.4475 2.9656 59.9651ZM38.296 63.4747H20.3752V63.8091H38.296V63.4747ZM71.0344 58.1075H68.2696C67.5496 58.1075 66.916 58.5755 66.6856 59.2667C66.5128 59.7923 66.304 60.3107 66.052 60.8003C65.7208 61.4483 65.836 62.2331 66.3472 62.7443L68.3056 64.7027L65.3608 67.6475L63.4096 65.6963C62.8984 65.1851 62.1208 65.0627 61.4656 65.4011C60.976 65.6531 60.4576 65.8691 59.932 66.0347C59.2336 66.2579 58.7728 66.8987 58.7728 67.6187V70.3835H54.604V67.6187C54.604 66.8987 54.136 66.2579 53.4448 66.0347C52.9192 65.8619 52.408 65.6531 51.9112 65.4011C51.2632 65.0699 50.4784 65.1851 49.9672 65.6963L48.016 67.6475L45.0712 64.7027L47.0224 62.7515C47.1664 62.6075 47.2744 62.4491 47.3536 62.2763C47.3752 62.2331 47.3968 62.1827 47.4112 62.1395C47.5624 61.7147 47.5408 61.2395 47.3248 60.8147C47.0728 60.3251 46.8568 59.8067 46.6912 59.2811C46.468 58.5827 45.8272 58.1219 45.1072 58.1219H42.3424V53.9531H45.1072C45.8272 53.9531 46.4608 53.4851 46.6912 52.7939C46.864 52.2683 47.0728 51.7571 47.3248 51.2603C47.656 50.6123 47.5408 49.8275 47.0296 49.3163L45.0712 47.3579L48.016 44.4131L49.9672 46.3643C50.4784 46.8755 51.256 46.9979 51.9112 46.6595C52.408 46.4075 52.9192 46.1915 53.4448 46.0259C54.1432 45.8027 54.604 45.1619 54.604 44.4419V41.6771H58.7728V44.4419C58.7728 45.1619 59.2408 45.7955 59.932 46.0259C60.4576 46.1987 60.9688 46.4075 61.4656 46.6595C62.1136 46.9907 62.8984 46.8755 63.4096 46.3643L65.368 44.4131L68.3128 47.3579L66.3544 49.3163C65.8432 49.8275 65.728 50.6051 66.0592 51.2603C66.3112 51.7499 66.5272 52.2683 66.6928 52.7939C66.916 53.4923 67.5568 53.9531 68.2768 53.9531H71.0416V58.1075H71.0344Z" fill="#2196F3" stroke="#2196F3" strokeWidth="0.5" />
                    <path d="M26.4278 12.7186H47.1494C47.6894 12.7186 48.1358 12.2794 48.1358 11.7322C48.1358 11.1922 47.6966 10.7458 47.1494 10.7458H26.4278C25.8878 10.7458 25.4414 11.185 25.4414 11.7322C25.4486 12.2794 25.8878 12.7186 26.4278 12.7186Z" fill="#2196F3" stroke="#2196F3" strokeWidth="0.5" />
                    <path d="M26.4278 18.5219H47.1494C47.6894 18.5219 48.1358 18.0827 48.1358 17.5355C48.1358 16.9955 47.6966 16.5491 47.1494 16.5491H26.4278C25.8878 16.5491 25.4414 16.9883 25.4414 17.5355C25.4486 18.0827 25.8878 18.5219 26.4278 18.5219Z" fill="#2196F3" stroke="#2196F3" strokeWidth="0.5" />
                    <path d="M9.30364 20.7035C10.506 21.5459 11.9316 21.9923 13.4148 21.9923C17.382 21.9923 20.6148 18.7595 20.6148 14.7923C20.6148 10.8251 17.382 7.59229 13.4148 7.59229C12.414 7.59229 11.4492 7.79389 10.542 8.18989C7.91404 9.33469 6.21484 11.9267 6.21484 14.7923C6.22204 17.1539 7.37404 19.3643 9.30364 20.7035ZM11.3268 9.99709C11.982 9.70909 12.6876 9.56509 13.4148 9.56509C16.302 9.56509 18.6492 11.9123 18.6492 14.7995C18.6492 17.6867 16.302 20.0339 13.4148 20.0339C12.3348 20.0339 11.3052 19.7099 10.4268 19.0979C9.02284 18.1187 8.18044 16.5131 8.18044 14.8067C8.18764 12.7115 9.41884 10.8323 11.3268 9.99709Z" fill="#2196F3" stroke="#2196F3" strokeWidth="0.5" />
                    <path d="M12.5993 16.9306C12.7793 17.1682 13.0601 17.305 13.3625 17.3122C13.3697 17.3122 13.3769 17.3122 13.3769 17.3122C13.6721 17.3122 13.9457 17.1826 14.1329 16.9594L16.4657 14.1586C16.8113 13.741 16.7537 13.1218 16.3433 12.7762C15.9257 12.4306 15.3065 12.4882 14.9609 12.8986L13.4057 14.7634L13.0241 14.2738C12.6929 13.8418 12.0737 13.7698 11.6417 14.101C11.2097 14.4322 11.1377 15.0514 11.4689 15.4834L12.5993 16.9306Z" fill="#2196F3" stroke="#2196F3" strokeWidth="0.5" />
                    <path d="M26.4278 30.7186H47.1494C47.6894 30.7186 48.1358 30.2794 48.1358 29.7322C48.1358 29.1922 47.6966 28.7458 47.1494 28.7458H26.4278C25.8878 28.7458 25.4414 29.185 25.4414 29.7322C25.4486 30.2794 25.8878 30.7186 26.4278 30.7186Z" fill="#2196F3" stroke="#2196F3" strokeWidth="0.5" />
                    <path d="M26.4278 36.5219H47.1494C47.6894 36.5219 48.1358 36.0827 48.1358 35.5355C48.1358 34.9955 47.6966 34.5491 47.1494 34.5491H26.4278C25.8878 34.5491 25.4414 34.9883 25.4414 35.5355C25.4486 36.0827 25.8878 36.5219 26.4278 36.5219Z" fill="#2196F3" stroke="#2196F3" strokeWidth="0.5" />
                    <path d="M9.30364 38.7035C10.506 39.5459 11.9316 39.9923 13.4148 39.9923C17.382 39.9923 20.6148 36.7595 20.6148 32.7923C20.6148 28.8251 17.382 25.5923 13.4148 25.5923C12.414 25.5923 11.4492 25.7939 10.542 26.1899C7.91404 27.3347 6.21484 29.9267 6.21484 32.7923C6.22204 35.1539 7.37404 37.3643 9.30364 38.7035ZM11.3268 27.9971C11.982 27.7091 12.6876 27.5651 13.4148 27.5651C16.302 27.5651 18.6492 29.9123 18.6492 32.7995C18.6492 35.6867 16.302 38.0339 13.4148 38.0339C12.3348 38.0339 11.3052 37.7099 10.4268 37.0979C9.02284 36.1187 8.18044 34.5131 8.18044 32.8067C8.18764 30.7115 9.41884 28.8323 11.3268 27.9971Z" fill="#2196F3" stroke="#2196F3" strokeWidth="0.5" />
                    <path d="M12.5993 34.9306C12.7793 35.1682 13.0601 35.305 13.3625 35.3122C13.3697 35.3122 13.3769 35.3122 13.3769 35.3122C13.6721 35.3122 13.9457 35.1826 14.1329 34.9594L16.4657 32.1586C16.8113 31.741 16.7537 31.1218 16.3433 30.7762C15.9257 30.4306 15.3065 30.4882 14.9609 30.8986L13.4057 32.7634L13.0241 32.2738C12.6929 31.8418 12.0737 31.7698 11.6417 32.101C11.2097 32.4322 11.1377 33.0514 11.4689 33.4834L12.5993 34.9306Z" fill="#2196F3" stroke="#2196F3" strokeWidth="0.5" />
                    <path d="M13.7703 43.4052C12.7695 43.4052 11.8047 43.6067 10.8975 44.0027C8.26951 45.1475 6.57031 47.7396 6.57031 50.6052C6.57031 52.9596 7.72231 55.17 9.65911 56.5092C10.8615 57.3516 12.2871 57.7979 13.7703 57.7979C17.7375 57.7979 20.9703 54.5651 20.9703 50.5979C20.9703 46.6379 17.7375 43.4052 13.7703 43.4052ZM13.7703 55.8396C12.6903 55.8396 11.6607 55.5155 10.7823 54.9035C9.37831 53.9243 8.53591 52.3187 8.53591 50.6123C8.53591 48.5315 9.76711 46.6452 11.6823 45.81C12.3375 45.522 13.0431 45.3779 13.7703 45.3779C16.6575 45.3779 19.0047 47.7251 19.0047 50.6123C19.0047 53.4923 16.6575 55.8396 13.7703 55.8396Z" fill="#2196F3" stroke="#2196F3" strokeWidth="0.5" />
                  </svg>

                  <div className="text-[#212121] space-y-1.5 ">
                    <p className="text-lg font-semibold leading-6">Career Action Plan </p>
                    <p className="text-base font-normal">It helps you chart a plan of action to advance your career goals.
                    </p>
                  </div>
                </div>
                <div className="flex flex-col bg-[#fff] p-6 px-4 gap-4 rounded-md items-start box-shadow-custom  w-full hover:border-[#2196F3] border border-transparent ">
                  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 72 74" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M43.0623 44.5503C45.4634 42.5318 46.9902 39.5103 46.9902 36.1292C46.9902 35.7145 46.9645 35.2999 46.9227 34.8949H62.1456C63.1678 34.8949 64.1481 34.4866 64.8713 33.7634C65.5946 33.0402 66.0028 32.0599 66.0028 31.0377V4.85424C66.0028 2.7264 64.2734 0.99707 62.1456 0.99707H9.85521C7.72737 0.99707 5.99805 2.7264 5.99805 4.85424V31.0377C5.99805 32.0599 6.40626 33.0402 7.12948 33.7634C7.8527 34.4866 8.83305 34.8949 9.85521 34.8949H25.0782C25.0364 35.2999 25.0107 35.7145 25.0107 36.1292C25.0107 39.5106 26.5375 42.532 28.9385 44.5503H28.3149C25.721 44.5503 23.2363 45.5789 21.4042 47.4111C19.572 49.2433 18.5434 51.7279 18.5434 54.3218V71.7113C18.5434 72.4217 19.1188 72.9971 19.8292 72.9971H52.1718C52.8821 72.9971 53.4575 72.4217 53.4575 71.7113V54.3218C53.4575 51.7279 52.4289 49.2432 50.5967 47.4111C48.7645 45.5789 46.2799 44.5503 43.686 44.5503H43.0623ZM46.4598 70.4252H50.8859V54.3218C50.8859 52.4093 50.1273 50.5803 48.7773 49.2304C47.4274 47.8804 45.5984 47.1218 43.6859 47.1218H28.3148C26.4023 47.1218 24.5734 47.8803 23.2234 49.2304C21.8734 50.5803 21.1148 52.4093 21.1148 54.3218V70.4252H25.5409V61.3902C25.5409 60.6798 26.1162 60.1045 26.8266 60.1045C27.5337 60.1045 28.1123 60.6798 28.1123 61.3902V70.4252H43.8882V61.3902C43.8882 60.6798 44.4668 60.1045 45.1739 60.1045C45.8843 60.1045 46.4597 60.6798 46.4597 61.3902L46.4598 70.4252ZM36.0004 27.7137C40.6483 27.7137 44.4183 31.4873 44.4183 36.1292C44.4183 40.777 40.648 44.5503 36.0004 44.5503C31.3529 44.5503 27.5826 40.7768 27.5826 36.1292C27.5826 31.4877 31.3529 27.7137 36.0004 27.7137ZM46.3084 32.3231H62.1452C62.4827 32.3231 62.8138 32.1849 63.0517 31.947C63.2928 31.7059 63.431 31.3781 63.431 31.0373V4.85388C63.431 4.14352 62.8524 3.56816 62.1453 3.56816H9.85486C9.14772 3.56816 8.56914 4.14352 8.56914 4.85388V31.0373C8.56914 31.3781 8.70735 31.7059 8.94843 31.947C9.18628 32.1849 9.51736 32.3231 9.85489 32.3231H25.6917C27.241 28.1316 31.275 25.1423 35.9997 25.1423C40.7244 25.1423 44.7598 28.1316 46.3084 32.3231Z" fill="#2196F3" stroke="#2196F3" strokeWidth="0.5" />
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M15.8666 21.6222L19.5599 25.3154C20.0613 25.8169 20.8778 25.8169 21.3792 25.3154L34.3006 12.394C34.802 11.8926 34.802 11.0762 34.3006 10.5748C33.7991 10.0734 32.9827 10.0733 32.4813 10.5748L20.4692 22.5869L17.6888 19.8033C17.1841 19.3019 16.3709 19.3019 15.8663 19.8033C15.3649 20.3048 15.3652 21.1208 15.8666 21.6222Z" fill="#2196F3" />
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M49.0542 16.0586L43.4356 10.4432C42.9341 9.94178 42.1177 9.94178 41.6163 10.4432C41.1149 10.9447 41.1149 11.7611 41.6163 12.2625L47.2349 17.8811L41.6163 23.4964C41.1149 23.9979 41.1149 24.8143 41.6163 25.3157C42.1177 25.8171 42.9342 25.8171 43.4356 25.3157L49.0542 19.6971L54.6695 25.3157C55.171 25.8171 55.9874 25.8171 56.4888 25.3157C56.9902 24.8143 56.9902 23.9978 56.4888 23.4964L50.8702 17.8811L56.4888 12.2625C56.9902 11.761 56.9902 10.9446 56.4888 10.4432C55.9874 9.94178 55.1709 9.94178 54.6695 10.4432L49.0542 16.0586Z" fill="#2196F3" />
                  </svg>

                  <div className="text-[#212121] space-y-1.5 ">
                    <p className="text-lg font-semibold leading-6">Informed Decision-Making </p>
                    <p className="text-base font-normal">It offers extensive insights into a variety of careers to support your decision-making process.
                    </p>
                  </div>
                </div>

              </div>

            </section>

          </div>
        </section>






        {/* Contact Us */}
        <section className="py-20 bg-[#F9F9FC] space-y-10" >
          {/* <h2 data-aos="fade-up" className="xl:text-5xl text-4xl leading-[3rem] xl:leading-[3.5rem] font-bold text-[#212121] text-center aos-init aos-animate capitalize">Get in Touch</h2> */}
          <div className="grid w-full grid-cols-1 gap-8 px-4 mx-auto text-gray-100 2xl:w-9/12 xl:w-11/12 xl:px-0 lg:grid-cols-2">

            <div data-aos="fade-right" className="space-y-4 ">
              <div data-aos="fade-up" className="space-y-2 text-[#212121]">
                <h2 className="xl:text-5xl text-4xl leading-[3rem] xl:leading-[3.5rem] font-medium text-[#212121]  capitalize">
                  Get in touch
                </h2>
                <p className="lg:text-lg text-base text-[#212121]">
                  For customer support and query, get in touch with us.
                </p>
              </div>

              <div className="space-y-0 ">
                <div data-aos="fade-up" className="flex flex-row items-center gap-6 py-4 border-b">
                  <div
                    className="flex justify-center items-center border w-16 h-16 bg-white rounded-full text-[#212121] "
                    href="#0"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="icon icon-tabler icon-tabler-mail"
                      width="32"
                      height="32"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <rect x="3" y="5" width="18" height="14" rx="2" />
                      <polyline points="3 7 12 13 21 7" />
                    </svg>
                  </div>
                  <div className=" mt-1 text-[#212121] flex-1">
                    <h1 className="text-xl font-semibold ">
                      Email
                    </h1>
                    <p className="text-base ">connect@happyplus.in</p>
                  </div>
                </div>

                <div data-aos="fade-up" className="flex flex-row items-center gap-6 py-4 ">
                  <div
                    className="flex justify-center items-center border w-16 h-16 bg-white rounded-full text-[#3D405B] "
                    href="#0"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="32"
                      height="32"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <line x1="3" y1="21" x2="21" y2="21" />
                      <line x1="9" y1="8" x2="10" y2="8" />
                      <line x1="9" y1="12" x2="10" y2="12" />
                      <line x1="9" y1="16" x2="10" y2="16" />
                      <line x1="14" y1="8" x2="15" y2="8" />
                      <line x1="14" y1="12" x2="15" y2="12" />
                      <line x1="14" y1="16" x2="15" y2="16" />
                      <path d="M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16" />
                    </svg>
                  </div>
                  <div className=" mt-1 text-[#3D405B] flex-1">
                    <h1 className="text-xl font-semibold ">
                      Office Address:
                    </h1>
                    <p className="text-base ">
                    HappyPlus Consulting Pvt. Ltd. Express Zone, Western Express Highway, Malad East, Mumbai – 400097
                    </p>
                  </div>
                </div>
              </div>

              <div className="flex items-center justify-center">
                <img
                  data-aos="fade-right"
                  src="/img/domaim/contact-us.svg"
                  alt="contact-us"
                  className="flex items-center justify-center p-6 w-6/6 "
                  width={490}
                  height={360}
                />
              </div>
            </div>

            <div data-aos="fade-left" className="space-y-6 ">
              <div data-aos="fade-up" className="space-y-2 ">
                <h2 className="xl:text-5xl text-4xl leading-[3rem] xl:leading-[3.5rem] font-medium text-[#3D405B]  capitalize">
                  Submit Details
                </h2>
                <p className="lg:text-lg text-base text-[#3D405B]">
                  Fill in your details below & we will get back to you soon!
                </p>
              </div>

              <div noValidate action className="grid grid-cols-1 gap-6 pt-2">
                <div className="space-y-2 ">
                  <label
                    htmlFor="name"
                    className="text-base font-medium text-[#212121] before:content-['*'] before:text-[#F14678] capitalize"
                  >
                    Full name
                  </label>
                  <input
                    className={`w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-4 text-base font-base text-[#212121] font-medium placeholder:font-normal outline-none focus:border-[#2196F3] focus:shadow-md ${!this.state.errorslogin["userName"]
                      ? "placeholder-gray-500"
                      : "border border-opacity-100 border-red-500 "
                      }`}
                    id="userName"
                    name="userName"
                    placeholder="Enter Name"
                    type="text"
                    onChange={this.inputChange}
                  />
                  {this.state.errorslogin["userName"] ? (
                    <div className="pt-2 text-xs text-red-600 invalid-feedback">
                      {this.state.errorslogin["userName"]}
                    </div>
                  ) : null}
                </div>

                <div className="space-y-2 ">
                  <label
                    htmlFor="email"
                    className="text-base font-medium text-[#212121] before:content-['*'] before:text-[#F14678]"
                  >
                    Email
                  </label>
                  <input
                    className={`w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-4 text-base font-base text-[#212121] font-medium placeholder:font-normal outline-none focus:border-[#2196F3] focus:shadow-md ${!this.state.errorslogin["email"]
                      ? "placeholder-gray-500"
                      : "border border-opacity-100 border-red-500 "
                      }`}
                    id="email"
                    name="email"
                    placeholder="Enter Email"
                    type="text"
                    onChange={this.inputChange}
                  />
                  {this.state.errorslogin["email"] ? (
                    <div className="pt-2 text-xs text-red-600 invalid-feedback">
                      {this.state.errorslogin["email"]}
                    </div>
                  ) : null}
                </div>

                <div className="space-y-2 ">
                  <label
                    htmlFor="phone"
                    className="text-base font-medium text-[#212121]"
                  >
                    Phone
                  </label>
                  <input
                    className="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-4 text-base font-base text-[#212121] font-medium placeholder:font-normal outline-none focus:border-[#2196F3] focus:shadow-md"
                    id="phone"
                    name="phone"
                    placeholder="+91 "
                    type="text"
                    onChange={this.inputChange}
                  />
                </div>

                <div className="space-y-2 ">
                  <label
                    htmlFor="message"
                    className="text-base font-medium text-[#212121]"
                  >
                    {" "}
                    Message (If Any)
                  </label>
                  <textarea
                    rows={3}
                    className="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-4 text-base font-base text-[#212121] font-medium placeholder:font-normal outline-none focus:border-[#2196F3] focus:shadow-md resize-none"
                    id="message"
                    name="message"
                    placeholder=""
                    type="text"
                    onChange={this.inputChange}
                  />
                </div>

                <button
                  type="button"
                  className="w-full  py-4 px-4 text-base font-medium tracking-wide text-white uppercase rounded bg-[#2196F3] hover:bg-[#1976D2] transition-all duration-150"
                  onClick={this.loginSubmit}
                >
                  {" "}
                  Send Message
                </button>

                {this.state.saveSuccess ? (
                  <button
                    type="button"
                    className="w-full flex space-x-4 items-center py-4 px-4 text-base  tracking-wide text-[#4CAF50] rounded bg-[#4CAF5012]"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="icon icon-tabler icon-tabler-circle-check"
                      width="30"
                      height="30"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <circle cx="12" cy="12" r="9" />
                      <path d="M9 12l2 2l4 -4" />
                    </svg>
                    <span>Your query has been successfully sent!</span>
                  </button>
                ) : null}
              </div>
            </div>
          </div>
        </section>

        <Ready />

        <Footer
          props2={this.props}
          prodList={getAssessmentPackagesShortListData}
          gotoMyAccount={this.gotoMyAccount}
        />
      </div>
    );
  }
}
TeenPersonalizedReport.defaultProps = {
  center: { lat: 26.953021, lng: 75.739797 },
  zoom: 15,
};
function mapStateToProps(state) {
  //console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { questions, user, assessment } = state;
  return {
    loggingIn,
    questions,
    user,
    assessment,
  };
}

export default connect(mapStateToProps)(TeenPersonalizedReport);
